import React, { useState } from "react";
import {
  FaLeaf,
  FaFish,
  FaDrumstickBite,
  FaUtensils,
  FaStar,
  FaWeightHanging,
  FaBoxOpen,
  FaClock,
} from "react-icons/fa";
import { MdDinnerDining } from "react-icons/md";
import { Link } from "react-scroll";

const menuCategories = [
  { id: "all", name: "Pełna oferta", icon: FaUtensils },
  { id: "meat", name: "Dania Mięsne", icon: FaDrumstickBite },
  { id: "fish", name: "Ryby", icon: FaFish },
  { id: "vege", name: "Wegetariańskie", icon: FaLeaf },
  { id: "special", name: "Zestawy Dnia", icon: FaStar },
];

const menuItems = [
  {
    id: 1,
    title: "Placki ziemniaczane po węgiersku",
    description:
      "Z gulaszem wieprzowym, papryką i cebulą, serwowane z kleksem śmietany.",
    weight: "600g",
    saladWeight: "150g",
    price: "39.00",
    category: "meat",
    popular: true,
  },
  {
    id: 2,
    title: "Filet z kurczaka w cieście francuskim",
    description: "Z tapenadą oliwkową i bukietem warzyw.",
    weight: "600g",
    price: "42.00",
    category: "meat",
  },
  {
    id: 3,
    title: "Makaron farfalle w sosie szpinakowo-serowym i kurczakiem",
    description: "",
    weight: "700g",
    price: "38.00",
    category: "meat",
  },
  {
    id: 4,
    title: "Pierogi z kapustą i mięsem",
    description: "Okraszone skwareczkami, 10szt",
    price: "30.00",
    weight: "10 szt.",

    category: "meat",
    popular: true,
  },
  {
    id: 5,
    title: "Bitki wołowe w sosie z czerwonego wina",
    description: "Kluski śląskie, surówka.",
    weight: "450g",
    saladWeight: "150g",
    price: "49.00",
    category: "meat",
  },
  {
    id: 6,
    title: "Pieczona papryka faszerowana",
    description:
      "Z pikantnym nadzieniem mięsnym, kaszą kus-kus, sosem tysiąca wysp.",
    weight: "450g / 50ml(sos)",
    price: "39.00",
    category: "meat",
  },
  {
    id: 7,
    title: "Sałatka makaronowa z kurczakiem",
    description: "Suszone pomidory, rukola, pestki słonecznika.",
    weight: "450g",
    price: "27.00",
    category: "meat",
  },
  {
    id: 8,
    title: "Zupa krem z dyni",
    description: "Z grzankami.",
    weight: "450ml / 20g(grzanki)",
    price: "18.00",
    category: "vege",
  },
  {
    id: 9,
    title: "Zestaw Dnia",
    description: "Zupa + Drugie",
    weight: "450g / 450ml",
    saladWeight: "150g",
    price: "30.00",
    category: "special",
    popular: true,
  },
  {
    id: 10,
    title: "Zupa dnia",
    description: "",
    weight: "450ml",
    price: "13.00",
    category: "special",
  },
  {
    id: 11,
    title: "Drugie danie z zestawu dnia",
    description: "",
    weight: "450g",
    saladWeight: "150g",
    price: "25.00",
    category: "special",
  },
];

const MenuItem = ({ item }) => (
  <div className="bg-white border border-stone-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col h-full">
    <div className="px-4 py-2 bg-stone-50 border-b border-stone-100 flex justify-between items-center">
      <span className="text-[10px] font-bold uppercase tracking-wider text-stone-400 flex items-center gap-1">
        <MdDinnerDining className="text-[9px]" /> Numer:{" "}
        {String(item.id).padStart(1, "0")}
      </span>
      {item.popular && (
        <span className="bg-orange-100 text-orange-600 text-[9px] font-black px-2 py-0.5 rounded uppercase tracking-tighter">
          Popularne
        </span>
      )}
    </div>

    <div className="p-5 flex-grow flex flex-col">
      <div className="flex justify-between items-start gap-4 mb-2">
        <h3 className="text-lg font-bold text-stone-800 leading-tight">
          {item.title}
        </h3>
        <div className="text-xl font-black text-cream-700 whitespace-nowrap">
          {item.price}{" "}
          <span className="text-xs font-normal text-stone-500 italic">zł</span>
        </div>
      </div>

      <p className="text-stone-500 text-sm mb-6 leading-relaxed">
        {item.description}
      </p>

      <div className="mt-auto grid grid-cols-2 gap-2">
        <div className="bg-stone-50 rounded-lg p-2 border border-stone-100">
          <div className="text-[9px] text-stone-400 uppercase font-bold mb-0.5">
            Zawartość
          </div>
          <div className="flex items-center gap-1.5 text-stone-700 font-bold text-xs">
            <FaWeightHanging className="text-stone-300" />
            {item.weight || "---"}
          </div>
        </div>

        <div
          className={`rounded-lg p-2 border ${item.saladWeight ? "bg-green-50 border-green-100 text-green-700" : "bg-stone-50 border-stone-100 text-stone-400"}`}
        >
          <div className="text-[9px] uppercase font-bold mb-0.5 opacity-70 italic">
            Surówka
          </div>
          <div className="flex items-center gap-1.5 font-bold text-xs">
            <FaLeaf
              className={`${item.saladWeight ? "text-green-400" : "text-stone-200"}`}
            />
            {item.saladWeight || "brak"}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default function CateringMenu() {
  const [activeCategory, setActiveCategory] = useState("all");

  const filteredItems =
    activeCategory === "all"
      ? menuItems
      : menuItems.filter((item) => item.category === activeCategory);

  return (
    <section className="relative py-20 overflow-hidden" id="menu">
      <div className="absolute inset-0 bg-gradient-to-br from-cream-100 to-cream-200" />

      {/* Wave Top SVG */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0]">
        <svg
          className="relative block w-[calc(200%+1.3px)] h-[70px]"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M0,0V27.35C151.52,89.13,320,120,480,120s328.48-30.87,480-92.65V0Z"
            fill="white"
          />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4" id="menu2">
        {/* Nagłówek */}
        <div className="text-center mb-12">
          <p class="mt-2 text-4xl sm:text-5xl lg:text-6xl font-bold text-charcoal-800 animate-fadeInUp animation-delay-100">
            Nasze
            <span className="text-cream-700"> specjalności</span>
          </p>
          <p class="mt-4 text-xl text-charcoal-600 max-w-3xl mx-auto ">
            Odkryj wyjątkowe dania przygotowane z pasją i najlepszych składników
          </p>
        </div>

        {/* Filtry */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {menuCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`flex items-center gap-2 px-5 py-2 rounded-lg font-bold text-xs uppercase tracking-wider transition-all ${
                activeCategory === cat.id
                  ? "bg-stone-800 text-white shadow-md"
                  : "bg-white/80 backdrop-blur-sm text-stone-500 hover:bg-white border border-stone-200"
              }`}
            >
              <cat.icon
                className={
                  activeCategory === cat.id
                    ? "text-cream-400"
                    : "text-stone-300"
                }
              />
              {cat.name}
            </button>
          ))}
        </div>

        {/* Grid produktów */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredItems.map((item) => (
            <MenuItem key={item.id} item={item} />
          ))}
        </div>

        <div className="mt-6 text-center">
          <p className="text-[11px] italic font-bold">
            * Wszystkie podane ceny zawierają opłatę SUP
          </p>
        </div>

        <div className="mt-12 max-w-2xl mx-auto">
          <div className="bg-white/40 backdrop-blur-md border border-white rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-6 shadow-sm">
            <div className="flex items-center gap-4 text-left">
              <div>
                <h4 className="font-bold text-stone-800 text-sm uppercase tracking-wide">
                  Czas na zamówienie
                </h4>
                <p className="text-stone-500 text-xs">
                  Przyjmujemy zamówienia od godziny{" "}
                  <span className="font-bold text-stone-700">08:00</span>{" "}
                  każdego dnia.
                </p>
              </div>
            </div>

            <Link to="contact-us" smooth={true} duration={500} offset={-80}>
              <button className="bg-stone-800 hover:bg-stone-900 text-white text-[11px] font-black uppercase tracking-[0.15em] px-8 py-3 rounded-lg transition-all shadow-sm active:scale-95">
                Zadzwoń i zamów
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
